import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";

const ITEMS = [
  "Insurance",
  "Energy",
  "Finance",
  "Payments",
  "When in need — CallMe📲Gerard",
  "Cut costs",
  "Grow smarter",
  "Negotiate better",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-black/20 bg-fog py-6 text-ink"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <span key={item} className="mx-10 flex items-center gap-10">
            <span
              className={`whitespace-nowrap font-serif text-2xl md:text-3xl ${
                i % 2 ? "italic" : ""
              }`}
            >
              {item}
            </span>
            <Diamond className="h-3 w-3 fill-navy text-navy" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
